import React from "react";
import Modal from "react-bootstrap/Modal";

import "./SandBoxModal.css";


function SandboxModal({ title, iframe, showModal, closeModal }) {
  return (
    <Modal show={showModal} onHide={closeModal} className='sandBoxModal'>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div dangerouslySetInnerHTML={{ __html: iframe }} />
      </Modal.Body>
    </Modal>
  );
}

export default SandboxModal;
